'use strict';

import {reverseUrl} from 'utils/django';

import './style.css';
import modalDirective from '../../rest-modal';
import template from './template.html';


export default modalDirective({
	template: template,
	resolve: {
		users: resolveActiveUsersForIncident,
	}
});


function resolveActiveUsersForIncident($incident, $http) {
	'ngInject';

	var url = reverseUrl('users:user-list') + '?active=true';
	return $http.get(url).then(function(response) {
		var users = [];
		var teamUUIDs = $incident.team.map(function(incidentUser) {
			return incidentUser.user.uuid;
		});
		response.data.forEach(function(user) {
			if (teamUUIDs.indexOf(user.uuid) == -1) {
				users.push(user);
			}
		});
		return users;
	});
}
